<div class="jumbotron vertical-center">
  <div class="text-center m-auto">
    <h1>Oops!</h1>
    <h2>404 {{ 'NOT_FOUND_MESSAGE' | translate }}</h2>
    <p>{{ 'NOT_FOUND_MESSAGE' | translate }}</p>

    <button type="button" class="lg-button" (click)="goHome()">{{ 'NOT_FOUND_HOME_BUTTON' | translate }}</button>
  </div>
</div>
